(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fg-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('fg-wishlist-dialog');
  if (!dialog || !dialog.showModal || customElements.get('fg-wishlist-button')) return;
  const key = 'flexigrip:wishlist:v1';
  const text = dialog.dataset;
  const list = dialog.querySelector('[data-fg-wishlist-list]');
  const toast = document.getElementById('fg-wishlist-status');
  let items = [];
  let storageAvailable = true;
  let toastTimer;
  let opener;
  const normalize = (data) => {
    if (!Array.isArray(data)) return [];
    const seen = new Set();
    return data.slice(0, 50).flatMap(item => {
      if (!item || !/^\d{1,20}$/.test(String(item.id)) || typeof item.title !== 'string' || !item.title.trim()) return [];
      try {
        const url = new URL(item.url, location.origin);
        if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?products\/[^/]+\/?$/.test(url.pathname) || seen.has(String(item.id))) return [];
        let image = '';
        if (typeof item.image === 'string' && item.image) {
          const imageUrl = new URL(item.image, location.origin);
          if (imageUrl.protocol === 'https:' && (imageUrl.origin === location.origin || imageUrl.hostname === 'cdn.shopify.com')) image = imageUrl.href;
        }
        seen.add(String(item.id));
        return [{id:String(item.id), title:item.title.slice(0, 250), url:url.pathname, image}];
      } catch { return []; }
    });
  };
  const read = () => {
    if (!storageAvailable) return items;
    try {
      const raw = localStorage.getItem(key);
      try { return normalize(JSON.parse(raw || '[]')); } catch { return []; }
    } catch { storageAvailable = false; return items; }
  };
  const announce = message => {
    clearTimeout(toastTimer);
    if (dialog.open) {
      dialog.querySelector('[data-fg-wishlist-message]').textContent = message;
    } else {
      toast.textContent = message;
      toast.hidden = false;
      toastTimer = setTimeout(() => { toast.hidden = true; }, 3000);
    }
  };
  const syncButton = element => {
    const button = element.querySelector('button');
    if (!button) return;
    element.hidden = false;
    if (button.hasAttribute('data-fg-save')) {
      const saved = items.some(item => item.id === button.dataset.id);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? text.unsave : text.save}: ${button.dataset.title}`);
    } else {
      button.setAttribute('aria-expanded', String(dialog.open));
      const count = button.querySelector('.fg-wishlist-count');
      count.textContent = String(items.length);
      count.hidden = !items.length;
    }
  };
  const sync = () => document.querySelectorAll('fg-wishlist-button').forEach(syncButton);
  const render = () => {
    list.replaceChildren();
    dialog.querySelector('[data-fg-wishlist-total]').textContent = `(${items.length})`;
    dialog.querySelector('[data-fg-wishlist-empty]').hidden = !!items.length;
    for (const item of items) {
      const row = document.createElement('li');
      row.className = 'fg-wishlist-item';
      const visual = document.createElement('div');
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 76;
        image.height = 94;
        image.loading = 'lazy';
        visual.append(image);
      }
      const body = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'fg-wishlist-item-title';
      title.href = item.url;
      title.textContent = item.title;
      const actions = document.createElement('div');
      actions.className = 'fg-wishlist-item-actions';
      const view = document.createElement('a');
      view.href = item.url;
      view.textContent = text.view;
      view.setAttribute('aria-label', `${text.view}: ${item.title}`);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.fgRemove = item.id;
      remove.textContent = text.remove;
      remove.setAttribute('aria-label', `${text.remove}: ${item.title}`);
      actions.append(view, remove);
      body.append(title, actions);
      row.append(visual, body);
      list.append(row);
    }
  };
  const commit = (message) => {
    if (storageAvailable) {
      try { localStorage.setItem(key, JSON.stringify(items)); }
      catch { storageAvailable = false; }
    }
    sync();
    if (dialog.open) render();
    announce(storageAvailable ? message : text.temporary);
  };
  items = read();
  customElements.define('fg-wishlist-button', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => syncButton(this)); }
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const save = target?.closest('[data-fg-save]');
    if (save) {
      event.preventDefault();
      const item = normalize([save.dataset])[0];
      if (!item) return;
      items = read();
      const index = items.findIndex(saved => saved.id === item.id);
      if (index >= 0) items.splice(index, 1);
      else if (items.length < 50) items.unshift(item);
      else { announce(text.limit); return; }
      commit(index >= 0 ? text.removed : text.added);
      return;
    }
    const open = target?.closest('[data-fg-wishlist-open]');
    if (open) {
      opener = open;
      items = read();
      render();
      toast.hidden = true;
      dialog.querySelector('[data-fg-wishlist-message]').textContent = storageAvailable ? '' : text.temporary;
      dialog.showModal();
      document.documentElement.classList.add('fg-wishlist-open');
      sync();
    }
  });
  dialog.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest('[data-fg-wishlist-close]')) { dialog.close(); return; }
    const remove = target?.closest('[data-fg-remove]');
    if (remove) {
      const index = items.findIndex(item => item.id === remove.dataset.fgRemove);
      items = read().filter(item => item.id !== remove.dataset.fgRemove);
      commit(text.removed);
      const buttons = list.querySelectorAll('[data-fg-remove]');
      (buttons[Math.min(index, buttons.length - 1)] || dialog.querySelector('[data-fg-wishlist-close]')).focus();
    }
    if (target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('fg-wishlist-open');
    sync();
    if (opener?.isConnected) opener.focus();
  });
  const restore = () => { items = read(); sync(); if (dialog.open) render(); };
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) restore(); });
  window.addEventListener('pageshow', restore);
})();
  } catch(e) { console.error(e); }
})();

})();
